import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getRoles = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/roles', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchRole = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/roles/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createRole = async (data, callback) => {
    try {
        // Spatie permissions expects an array, so we don't use FormData here.
        const response = await risapi.post('/api/roles', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateRole = async (data, callback) => {
    try {
        // Use standard JSON for array data
        const response = await risapi.put(`/api/roles/${data.id}`, data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroyRole = async (role, callback) => {
    try {
        const response = await risapi.delete(`/api/roles/${role.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ role });
        }
    } catch (error) {
        callback(error);
    }
};
